import { createRouter, createWebHistory } from 'vue-router';
//import {central_data} from '@/lib/vendor/eve/central-data';

const routes = [

    //<editor-fold defaultstate="collapsed" desc="mod-grant">    
    {
        path: '/grant/:alias',
        name: 'main',
        props: true,
        component: () => import(/* webpackChunkName: "mod-main" */ '@/components/page')

    },

    //</editor-fold>

    {
        path: '/:catch(.*)',
        component: () => {
            return import('@/components/page');
        },
        props: true
    }
];
var route_id = 0;
const named_routes = routes.map(function (x) {
    if (!x.name) {
        x.name = ["rt", route_id].join('');
        route_id++;
    }
    return x;
});

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: named_routes
});

export default router
